export const CSS_CLASS_NAME_CHECKBOX_ICON = "custom-checkbox-icon";
export const CSS_CLASS_NAME_CHECKBOX_ICON_SVG = "custom-checkbox-icon-svg";
